module.exports = __webpack_public_path__ + "img/top-right.2cbedffa.png";